import { useTranslation } from '@mint-lib/i18n';
import { Locked } from '@mint-lib/icons';
import { Button, Card, typographyVariants } from '@mint-lib/tw-components';

type Props = {
  name: string;
  actionLabel?: string;
  disabled?: boolean;
  onOpen: () => void;
  ddActionName: string;
};

const PrivateFolderCard = ({
  name,
  actionLabel,
  disabled,
  onOpen,
  ddActionName,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  return (
    <Card
      variant="outlined"
      hover="noHover"
      className="flex h-22 w-67.5"
      contentClassName="flex w-full flex-col gap-4"
    >
      <Locked className="size-6 shrink-0 fill-icon-primary" />

      <div className="flex flex-row items-center justify-between gap-2">
        <div
          className={typographyVariants({
            variant: 'h6',
            color: 'primary',
          })}
        >
          {name}
        </div>

        <Button
          size="small"
          variant="outlined"
          disabled={disabled}
          onClick={onOpen}
          data-dd-action-name={ddActionName}
        >
          {actionLabel ?? t('Open')}
        </Button>
      </div>
    </Card>
  );
};

export { PrivateFolderCard };
